module.exports = __webpack_public_path__ + "img/icon-leftover-duration.b2dabc99.png";